import CustomAlphabetList from './CustomAlphabetList';

export default CustomAlphabetList;